<template>
  <div>
      <Card dis-hover style="min-height:400px;">
        <Form ref="queryForm" :label-width="80" label-position="left" inline>
          <FormItem label="售后着装:">
            <Select v-model="query.afterSalesAttire" style="width: 120px">
              <Option value=""> -- </Option>
              <Option :value="asa.value" v-for="(asa,index) in afterSalesAttireData" :key="index">{{asa.name}}</Option>
            </Select>
          </FormItem>
		  <FormItem label="工具:">
		    <Select v-model="query.tool" style="width: 120px">
		      <Option value=""> -- </Option>
		      <Option :value="tool.value" v-for="(tool,index) in toolData" :key="index">{{tool.name}}</Option>
		    </Select>
		  </FormItem>
          <FormItem label="创建时间:">
            <DatePicker v-model="query.createTime" type="daterange" @on-change="dateChange" style="width: 200px" placement="bottom-end" placeholder="请选择"></DatePicker>
          </FormItem>
          <FormItem :label-width="20">
            <Button icon="ios-search" type="primary" size="default" @click="getpage(1)" class="toolbar-btn">查询</Button>
            <Button icon="md-refresh" type="primary" size="default" @click="reset" class="toolbar-btn">重置</Button>
          </FormItem>
          <!-- </Row> -->
        </Form>
        <div>
          <Table :loading="loading" :columns="columns" no-data-text="暂无数据" border :data="list"></Table>
          <Page show-sizer show-total class-name="fengpage" :total="totalCount" class="margin-top-10" @on-change="pageChange" @on-page-size-change="pagesizeChange" :page-size="pageSize" :current="currentPage"></Page>
        </div>
      </Card>
    <div v-if="createLogModelShow">
      <createAfterSales :show="createLogModelShow" @close="closeModel" :customerId="customerId" :quotationId="quotationId" :isDetail="isDetail"></createAfterSales>
    </div>
  </div>
</template>
<script>
import Util from '../../../lib/util'
import createAfterSales from './createAfterSales.vue'
export default {
  components: { createAfterSales },
  props: {
    show: Boolean,
    customerId: Number,
	isDetail:Boolean
  },
  data() {
    return {
      model: true,
      query: {
        createTime: [],
        afterSalesAttire: null,
        tool: null,
        createTimeStart: '',
        createTimeEnd: '',
        customerId: this.customerId,
      },
      header: {
        Authorization: `Bearer ${Util.abp.auth.getToken()}`,
      },
      columns: [], //项目表头
      list: [], //项目数据
	  isDisable:false,
      afterSalesAttireData: [], //
      contactsData: [], //
      personnelSafetyData: [], //
      toolData: [], //
      pageSize: 10,
	  quotationId:null,
      currentPage: 1,
      totalCount: 0,
      loading: false,
      createLogModelShow: false,
    }
  },
  mounted() {
	this.getSelect()
    this.getColumns()
    this.getpage(1)
	if(this.isDetail){
		this.isDisable=this.isDetail
	}
  },
  methods: {
	//   获取下拉框数据
	async getSelect() {
	  const { data } = await this.$Ajax.get(
	    `/api/services/app/CustomerAfterSalesApiService/GetAfterSalesMgrInitData?customerId=${this.customerId}`
	  )
	  this.contactsData = data.result.contactsData
	  this.afterSalesAttireData = data.result.afterSalesAttireData
	  this.personnelSafetyData = data.result.personnelSafetyData
	  this.toolData = data.result.toolData
	},  
    getColumns() {
      this.columns = [
        {
          title: '售后着装',
          key: 'afterSalesAttireText',
          toolbar:true,
        },
        {
          title: '工具',
          key: 'toolText',
        },
		{
          title: '人员安全',
          key: 'personnelSafetyText',
        },
        {
          title: '联系人',
          key: 'contactsIdsText',
        },
        {
          title: '创建时间',
          key: 'creationTimeText',
        },
        {
          title: '操作',
          width: 200,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
				h(
				  'Button',
				  {
				    props: {
				      type: 'primary',
				      size: 'small',
				    },
				    style: {
				      marginRight: '5px',
				      display: this.isDisable ? '' : 'none',
				    },
				    on: {
				      click: () => {
				        this.openCreateProduct(params.row.id)
				      },
				    },
				  },
				  '详情'
				),	
            ])
          },
        },
       
      ]
    },
    // 关闭弹窗
    close(refresh) {
      this.$emit('close', refresh)
    },
    closeModel(refresh) {
      this.createLogModelShow = false
      this.quotationId=0
	  if(refresh){
        this.getpage(1)
      }
    },
    //新增日志
    openCreateLog() {
      this.createLogModelShow = true
    },
    //时间改变
    dateChange() {
      let time = this.query.createTime
      let start = time[0] ? this.$moment(time[0]).format('YYYY-MM-DD  HH:mm:ss') : ''
      let end = time[1] ? this.$moment(time[1]).format('YYYY-MM-DD  HH:mm:ss') : ''
      this.query.createTimeStart = start
      this.query.createTimeEnd = end
    },
    async getpage(params) {
      // console.log(this.rangeTime)
      this.query.MaxResultCount = this.pageSize
      this.query.SkipCount = (this.currentPage - 1) * this.pageSize
      if (params === 1) {
        this.query.SkipCount = 0
      }

      this.loading = true
      const data = await this.$Ajax.get('/api/services/app/CustomerAfterSalesApiService/QueryDto', {
        params: this.query,
      })
      this.list = data.data.result.items
      this.totalCount = data.data.result.totalCount
      this.loading = false
    },
    pageChange(page) {
      this.currentPage = page
      this.getpage()
    },
    pagesizeChange(pagesize) {
      this.pageSize = pagesize
      this.getpage()
    },
	// 创建产品
	openCreateProduct(quotationId) {
	  this.quotationId = quotationId
	  this.createLogModelShow = true
	},
    reset() {
      this.query = {
        createTime: [],
        afterSalesAttire: null,
        tool: null,
        createTimeStart: '',
        createTimeEnd: '',
        customerId: this.customerId,
      }
      this.getpage(1)
    },
  },
}
</script>
<style lang="less" scoped>
// /deep/.ivu-modal-fullscreen {
//   width: calc(~'100% - 256px') !important;
//   top: 0;
//   bottom: 0;
//   position: absolute;
//   left: 256px;
// }
</style>